import * as ContactConstants from "./constants";
export { ContactConstants };
export const getLabelName = (item) => {
    if (!item) {
        return "";
    }
    if (item.type === "individual") {
        return `${item.individualFirstName ?? ""} ${item.individualLastName ?? ""}`;
    }
    return `${item.organizationName ?? ""}`;
};
//# sourceMappingURL=index.js.map